import { useCallback } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { CallbackData } from '#src/app/pages/petitionDetails/shared/types';

export function useGetFormData(): (data: CallbackData) => Record<string, unknown> {
	const {
		data: { petition: details },
	} = usePetitionDetailsPageData();

	return useCallback(
		({ formData }: CallbackData) => ({
			petition_id: details.id,
			first_name: formData.firstName,
			last_name: formData.lastName,
			email: formData.email,
			city: formData.city,
			country_code: formData.countryCode,
			state_code: formData.stateCode,
			postal_code: formData.postalCode,
			public: formData.public,
			share_info: formData.shareInfoWithOrganization,
			...(formData.marketingCommsConsent && {
				marketing_comms_consent: formData.marketingCommsConsent.consentGiven,
				consent_name: formData.marketingCommsConsent.name,
				consent_text: formData.marketingCommsConsent.text as string,
			}),
		}),
		[details],
	);
}
